import React, { useState, useEffect } from 'react';
import { Sidebar } from 'primereact/sidebar';
import { Divider } from 'primereact/divider';
import { InputSwitch } from 'primereact/inputswitch';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import Conexao from '../../../providers/Conexao';

export default function SidebarRevendas(props) {
    const [empresa, setEmpresa] = useState({ ...props.empresa });
    const [empresaTemp, setEmpresaTemp] = useState({ ...props.empresa });
    const [open, setOpen] = useState(false)

    useEffect(() => {
        setEmpresa({ ...props.empresa });
        setEmpresaTemp({ ...props.empresa });
    }, [props.empresa, open]);

    const customHeader = (
        <div className="flex align-items-center gap-2">           
            <span className="font-bold text-xl">Revenda: {empresa.nome}</span>
        </div>
    );

    return (
        <>
            <Button severity='primary' 
             tooltip="Gerar relatório de equipametos monitorados" 
             tooltipOptions={{ position: 'left' }}
             onClick={()=>setOpen(!open)}>
                <i className='pi pi-cog'/>
        </Button>
        
        <Sidebar 
        onHide={() => setOpen(false)}
        header={customHeader} visible={open} style={{ minWidth: '40%' }} position="right" {...props}>
            <Divider />
            <div className="flex flex-wrap gap-0 pl-3 pr-4">
                {/* Exibindo informações da empresa */}
                
                <div className="col-12 md:col-6">
                    <span className="" style={{fontSize:'0.7rem'}}>CNPJ/CPF</span>
                    <div className="text-lg">{empresa.cpf_cnpj}</div>
                </div>

                <div className="col-12 md:col-6">
                    <span className="" style={{fontSize:'0.7rem'}}>Isc. Est/RG</span>
                    <div className="text-lg">{empresa.rg_insc}</div>
                </div>

                <div className="col-12 md:col-8">
                    <span className="" style={{fontSize:'0.7rem'}}>R. Social/Nome Completo</span>
                    <div className="text-lg">{empresa.nome}</div>
                </div>


                <div className="col-12 md:col-6">
                    <span className="" style={{fontSize:'0.7rem'}}>Endereço (Logradouro)</span>
                    <div className="text-lg">{empresa.logradouro}</div>
                </div>

                <div className="col-12 md:col-2">
                    <span className="" style={{fontSize:'0.7rem'}}>Nº</span>
                    <div className="text-lg">{empresa.numero}</div>
                </div>

                <div className="col-12 md:col-4">
                    <span className="" style={{fontSize:'0.7rem'}}>Complemento</span>
                    <div className="text-lg">{empresa.complemento}</div>
                </div>

                <div className="col-12 md:col-4">
                    <span className="" style={{fontSize:'0.7rem'}}>CEP</span>
                    <div className="text-lg">{empresa.cep}</div>
                </div>
                <div className="col-12 md:col-8">
                    <span className="" style={{fontSize:'0.7rem'}}>Bairro</span>
                    <div className="text-lg">{empresa.bairro}</div>
                </div>

                <div className="col-12 md:col-8">
                    <span className="" style={{fontSize:'0.7rem'}}>Cidade:</span>
                    <div className="text-lg">{empresa.cidade}</div>
                </div>

                <div className="col-12 md:col-2">
                    <span className="" style={{fontSize:'0.7rem'}}>Estado:</span>
                    <div className="text-lg">{empresa.estado}</div>
                </div>


                <div className="col-12 md:col-6">
                    <span className="" style={{fontSize:'0.7rem'}}>Telefone</span>
                    <div className="text-lg">{empresa.telefonecomercial}</div>
                </div>

                <div className="col-12 md:col-6">
                    <span className="" style={{fontSize:'0.7rem'}}>Celular</span>
                    <div className="text-lg">{empresa.telefonecelular}</div>
                </div>

                <div className="col-12 md:col-12">
                    <span className="" style={{fontSize:'0.7rem'}}>Email</span>
                    <div className="text-lg">{empresa.email}</div>
                </div>


                <br/>
                <Divider/>
                <br/>

                {/* Switch de Ativo */}
                <div className="col-12 md:col-4">
                    <span className="text-lg">Módulo Collector</span><br/>
                    <InputSwitch
                        style={{marginTop: '10px'}}
                        checked={empresa.habilitarcollector === 't'}
                        onChange={() => {
                            setEmpresa(prev => ({ ...prev, habilitarcollector: prev.habilitarcollector === 't' ? 'f' : 't' }))
                        }}
                    />
                </div>

                <div className="col-12 md:col-4">
                    <span className="text-lg">Módulo inventory</span><br/>
                    <InputSwitch
                        style={{marginTop: '10px'}}
                        checked={empresa.habilitarinventory === 't'}
                        onChange={() => {
                            setEmpresa(prev => ({ ...prev, habilitarinventory: prev.habilitarinventory === 't' ? 'f' : 't' }))
                        }}
                    />
                </div>

                <div className="col-12 md:col-4">
                    <span className="text-lg">Ativar Cobrança</span><br/>
                    <InputSwitch
                        style={{marginTop: '10px'}}
                        checked={empresa.habilitarcobranca === 't'}
                        onChange={() => {
                            setEmpresa(prev => ({ ...prev, habilitarcobranca: prev.habilitarcobranca === 't' ? 'f' : 't' }))
                        }}
                    />
                </div>

                <div className="col-12 md:col-4">
                    <span className="text-lg">Valor Fixo</span><br/>
                    <InputSwitch
                        style={{marginTop: '10px'}}
                        checked={empresa.valorfixo === 't'}
                        onChange={() => {
                            setEmpresa(prev => ({ ...prev, valorfixo: prev.valorfixo === 't' ? 'f' : 't' }))
                        }}
                    />
                </div>


                {/* Switch de Empresa Padrão */}
                <div className="col-12 md:col-12">
                    <span className="text-lg">Valor R$</span><br/>
                    <InputText
                        style={{marginTop: '10px'}}
                        value={empresa.valorcontratado}
                        onChange={(e) => {
                            setEmpresa(prev => ({ ...prev, valorcontratado: e.target.value }))
                        }
                            
                        }
                    />
                </div>

                <div className="mt-4 flex justify-content-end mt-2">
                    <Button severity="secondary" className="mt-2 mr-2" label="Cancelar" icon="pi pi-times" onClick={() => {
                            confirmDialog({
                            message: 'Deseja cancelar?',
                            header: 'Confirmação',
                            icon: 'pi pi-exclamation-triangle',
                            acceptLabel: 'Sim',
                            rejectLabel: 'Não',
                            accept: () => {setOpen(false)}
                        });
                    }} />
                    <Button severity="primary" className="mt-2 mr-2" label="Salvar" icon="pi pi-save" onClick={() => {                            
                            confirmDialog({
                            message: 'Confirma a inclusão desse novo Cliente?',
                            header: 'Confirmação',
                            icon: 'pi pi-exclamation-triangle',
                            acceptLabel: 'Sim',
                            rejectLabel: 'Não',
                            accept: () => {
                                 Conexao.post('empresasController/updateRevenda', {
                                    idusuario : empresa.idusuario, 
                                    razaoSocial : empresa.nome,       
                                    cnpj : empresa.cpf_cnpj,
                                    logradouro : empresa.logradouro, 
                                    numero : empresa.numero,
                                    cep : empresa.cep,
                                    complemento : empresa.complemento,
                                    bairro : empresa.bairro,
                                    cidade : empresa.cidade,
                                    estado : empresa.estado,
                                    email : empresa.email,
                                    habilitarCobranca : empresa.habilitarcobranca, 
                                    valorFixo : empresa.valorfixo, 
                                    valorContratado : empresa.valorcontratado ? empresa.valorcontratado : 0, 
                                    habilitarCollector : empresa.habilitarcollector, 
                                    habilitarInventory : empresa.habilitarinventory
                                    
                                }).then(response=>{
                                    
                                if(response.status == 200 && response.data.status =='OK'){
                                     props.updateRevenda(empresa)
                                     props.showMessage('success', 'Registro alterado com sucesso!')
                                }else{
                                     props.showMessage('warn', 'Não foi possível atualizar registro')    
                                }
                               
                                    setOpen(false)
                                }).catch(error=>{
                                     props.showMessage('danger', 'Não foi possível atualizar registro')
                                   setOpen(false)
                                })
                            } 
                        });
                    }} />
                </div>

                {/* Botões abaixo dos switches */}
      
            </div>
        </Sidebar>
        </>
    );
}
